import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import {
  meditationGirlImage,
} from '../../../assets'
import phpLogo from '../../../assets/php-branding.png'
import { MetadataContext } from '../../../common'
import { BrandName } from '../../EAP/EAP-constants'
import { phpFAQPath, phpProvidersProfilesPath } from '../../../routing/route.constants'
import './php-health-plan-landing-page.scss'
import { Col, Row, Spin } from 'antd'

const PHPHealthPlanLandingPage: React.FC = () => {
  const history = useHistory()
  const { checkCurrentBrand } = useContext(MetadataContext)

  const handleRequestAppointment = () => {
    window.open('https://forms.office.com/r/yEjJfHEGtm', '_blank', 'noopener,noreferrer')

  }

  const handleViewProviderProfiles = () => {
    history.push(phpProvidersProfilesPath)
  }

  const handleViewFAQs = () => {
    history.push(phpFAQPath)
  }

  return true ? (
    <Row className="ant-row flex sm:m-10 sm:mt-[3vh] xl:mt-[3vh] xs:rounded-2xl xs:-mt-4 justify-between">
      {/* Left Section */}
      <Col md={12}
        lg={12}
        className="flex flex-col gap-6 sm:items-center md:items-start justify-start md:pl-8 2xl:pl-40 w-full max-w-screen-md mt-32 md:mt-4 pr-2 sm:pt-[3vh] xl:pt-[3vh]">
        <p style={{ alignSelf: 'center' }} className="font-bold text-xl lg:text-2xl xl:text-3xl text-teal-blue">
          Welcome to Trusana.
        </p>

        {/* Meditation Illustration */}
        <img
          style={{ alignSelf: 'center' }}
          src={meditationGirlImage}
          alt="Meditation illustration"
          className="max-w-xs md:max-w-xs lg:max-w-sm xl:max-w-md"
        />

        {/* Brought to you by */}
        <div className="flex flex-col items-center" style={{ alignSelf: 'center' }}>
          <p className="text-shade/70 text-base md:text-lg mb-4">
            Brought to you by
          </p>
          <img
            src={phpLogo}
            alt="Providence Health Plan Logo"
          />
        </div>
      </Col>

      {/* Right Section - Card */}
      <Col xs={24}
        sm={24}
        md={12}
        lg={12}
        className="flex flex-col items-center lg:max-w-[55%] 2xl:max-w-[45%] drop-shadow-md md:mt-8">
        <div className="bg-white rounded-xl p-10 gap-6 flex flex-col xs:w-full md:w-[80%] md:mt-0">
          <div className="text-3xl pb-4 text-[#303F5C] font-semibold">
            <span className=" text-[#3F7A88] font-bold">Begin</span> your care
            here
          </div>

          <div className="text-shade">
            <p className="text-sm">
              Providence Health Plan members now use the Trusana platform
              for Behavioral Health Concierge (BHC). On Trusana, members
              can manage appointments online, participate in virtual visits,
              access their personalized plan of care, and track progress.
            </p>
            <p className="text-sm">
              All our mental health professionals are licensed clinical
              social workers.
            </p>
            <p className="text-sm">
              To get started, click or tap Request an Appointment or call
              us direct at{' '}
              <a
                href="tel:8663659355"
                className="font-bold text-shade hover:underline"
              >
                (866) 365-9355
              </a>.
            </p>
          </div>

          <div className="mb-8">
            <a
              href={phpFAQPath}
              onClick={(e) => {
                e.preventDefault()
                handleViewFAQs()
              }}
              className="text-shade underline text-sm font-bold cursor-pointer"
            >
              View our FAQs
            </a>
            {' '}to learn more.
          </div>

          <div className="flex flex-col gap-10">
            <button
              onClick={handleRequestAppointment}
              style={{ alignSelf: 'center' }}
              className="request-appointment-btn bg-shade cursor-pointer text-white rounded-full px-12 py-3 text-sm font-medium"
            >
              Request an Appointment
            </button>
            <div className="text-center">
              <a
                href={phpProvidersProfilesPath}
                onClick={(e) => {
                  e.preventDefault()
                  handleViewProviderProfiles()
                }}
                className="text-[#303F5C] underline text-base font-semibold cursor-pointer inline-block"
              >
                View Provider Profiles
              </a>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  ) : (
    <div className="flex items-center justify-center w-full">
      <Spin size="large" className="mt-[30vh]" />
    </div>
  )
}

export default PHPHealthPlanLandingPage
